import classes from './Features.module.scss';
import Button from '../../atoms/button/Button';
import FeaturesCarousel from '../../organisms/featuresCarousel/FeaturesCarousel';
import featuresSettings from './config/carouselSettings.json';

export default function Features(props) {
    /**
     * return null needed for react render func
     */
    if (!props) return null;

    const siteContent = props[0];
    const featuresContent = [props[1], props[2], props[3]];
    const navButton = props[4];

    return (
        <div className={`${classes.oCarouselPanel} oCarouselFeatured`}>
            <div className={`container`}>
                <div className={`row no-gutters`}>
                    <h2 className={`aSectionTitle _accent fntH2`}>{siteContent.site_header}</h2>
                </div>
            </div>
            <FeaturesCarousel config={featuresSettings} content={featuresContent} />

            <div className={classes.CtaWrapper}>
                <Button
                    url={navButton.href}
                    label={navButton.label}
                    style="btnPrimary"
                    isExternal="_parent"
                    iconPath=""
                />
            </div>
        </div>
    );
}
